export interface AuthPaths {
  login: string;
  storeLogin: string;
  register: string;
  forgotPWD: string;
  resetPWD: string;
  workspaces: string;
}

export const paths: AuthPaths = {
  login: "/login",
  storeLogin: "/login/store/:shop_token",
  register: "/register",
  forgotPWD: "/forgot-password",
  resetPWD: "/reset-password",
  workspaces: "/workspaces",
};
